
import { Component, Vue } from 'vue-property-decorator'
import { subscriptionModule } from '@/store'
import { isBrowser } from '@/utils/utility-manager'
@Component({
  name: 'RouteToProButton',
})
class RouteToProButton extends Vue {
  routeToPro(): void {
    if (!isBrowser()) {
      return
    }

    if (subscriptionModule.disableStripePayment) {
      // open Lambus PRO help center article if payment is disabled
      const locale = this.$i18n.locale === 'de' ? 'de' : 'en'
      window.open(
        `${process.env.LAMBUS_HELP_CENTER}/${locale}/article/about-lambus-pro`,
        '_blank',
      )
    } else {
      // open Lambus PRO purchase page if payment is enabled
      window.open(`${process.env.DASHBOARD_HOME}/pro/features`, '_blank')
    }
  }
}
export default RouteToProButton
